import React from 'react';

const RATING_TONE = {
  'Bullish context': 'up',
  'Bearish context': 'down',
  Neutral: 'neutral',
  Watch: 'watch',
  'Needs confirmation': 'watch',
};

export default function AIAnalystNote({ analysis, loading, error }) {
  if (loading) {
    return (
      <div className="ai-insight-card">
        <span className="ai-badge">Market Context</span>
        <span className="skeleton-bar" style={{ width: '100%' }} />
      </div>
    );
  }

  if (error) {
    return (
      <div className="ai-insight-card">
        <span className="ai-badge">Market Context</span>
        <div className="error-box">{error}</div>
      </div>
    );
  }

  if (!analysis) return null;

  const tone = RATING_TONE[analysis.rating] || 'neutral';

  return (
    <div className="ai-insight-card analyst-note">
      <span className="ai-badge">Market Context</span>

      <div className="analyst-rating-row">
        <span className={`rating-badge ${tone}`}>{analysis.rating}</span>
        <span className="input-hint">Confidence {analysis.confidence}%</span>
        <span className="input-hint">Risk: {analysis.riskLevel}</span>
      </div>

      <p className="reasoning">{analysis.summary}</p>

      {analysis.keyDrivers?.length > 0 && (
        <div className="analyst-note-section">
          <p className="metrics-label">Key drivers</p>
          <ul>
            {analysis.keyDrivers.map((d) => (
              <li key={d}>{d}</li>
            ))}
          </ul>
        </div>
      )}

      {analysis.risks?.length > 0 && (
        <div className="analyst-note-section">
          <p className="metrics-label">Risks</p>
          <ul>
            {analysis.risks.map((r) => (
              <li key={r}>{r}</li>
            ))}
          </ul>
        </div>
      )}

      {analysis.watchNext?.length > 0 && (
        <div className="analyst-note-section">
          <p className="metrics-label">Watch next</p>
          <ul>
            {analysis.watchNext.map((w) => (
              <li key={w}>{w}</li>
            ))}
          </ul>
        </div>
      )}

      <p className="input-hint" style={{ marginTop: 12 }}>
        AI analysis is informational only and is not financial advice.
      </p>
    </div>
  );
}
